export class EditPersonalImage
{
    constructor()
        {
            this.English = "Edit Personal Image";
            this.Arabic = "تعديل الصورة الشخصية";
        }
    English:string 
    Arabic:string 
}